import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { getpurchase } from '../redux/purchase';
import Progress from '../components/Loader';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function BasicModal(props) {
  const [open, setOpen] = React.useState(props.value);
  const [loading, setLoading] = React.useState(false);
  const [center, setCenter] = React.useState('none');
  const [personName, setPersonName] = React.useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const dispatch = useDispatch();
  const center_ = useSelector((state) => state.processingcenter);
  const agent = useSelector((state) => state.hauler);

  const names = ['Drying', 'Cleaning', 'Rebagging', 'Standardization'];

  const handleClose = () => {
    setOpen(false);
    props.setfalser();
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleChange = (event) => {
    const { target: { value } } = event;
    setPersonName(typeof value === 'string' ? value.split(',') : value);
  };

  const clearProcessForm = () => {
    setCenter('none');
    setPersonName([]);
    document.getElementById('rawqty').value = '';
    document.getElementById('rawunit').value = '';
    document.getElementById('finishedqty').value = '';
    document.getElementById('finishedunit').value = '';
    document.getElementById('date').value = '';
    document.getElementById('others').value = '';
  };

  const clearDispatchForm = () => {
    setCenter('none');
    setPersonName([]);
    document.getElementById('supplyqty').value = '';
    document.getElementById('supplyunit').value = '';
    document.getElementById('date').value = '';
    document.getElementById('others').value = '';
  };

  const processGoods = () => {
    const addProcess = async () => {
      setLoading(true);
      try {
        const res = await axios.post('https://server.agrotraciserp.com/api/purchase/editpurchase/', {
          id: props.chosen.id,
          processingcenter: center,
          processingtype: personName,
          status: 'Processed',
          rawqty: document.getElementById('rawqty').value,
          rawunit: document.getElementById('rawunit').value,
          finishedqty: document.getElementById('finishedqty').value,
          finishedunit: document.getElementById('finishedunit').value,
          date: document.getElementById('date').value,
          others: document.getElementById('others').value,
        });

        if (res.status === 200) {
          setLoading(false);
          dispatch(getpurchase({ data: res.data }));
          setSnackbarMessage('Processing submitted successfully!');
          setSnackbarOpen(true);
          clearProcessForm();
          setTimeout(() => handleClose(), 1500); // Close dialog after 1.5s
        } else {
          setLoading(false);
          setSnackbarMessage('Failed to submit processing.');
          setSnackbarOpen(true);
        }
      } catch (err) {
        setLoading(false);
        setSnackbarMessage('Error submitting processing.');
        setSnackbarOpen(true);
      }
    };

    return (
      <Box
        component="form"
        sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
        noValidate
        autoComplete="off"
      >
        <TextField
          id="outlined-select-currency-native"
          select
          label="Processing Center"
          value={center}
          onChange={(e) => setCenter(e.target.value)}
          SelectProps={{ native: true }}
        >
          <option value="none">Choose Center</option>
          {center_.map((list) => (
            <option key={list.centername} value={list._id}>
              {list.centername}
            </option>
          ))}
        </TextField>
        <FormControl sx={{ m: 1, width: 225 }}>
          <InputLabel id="demo-multiple-checkbox-label">Processing Type</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={personName}
            onChange={handleChange}
            input={<OutlinedInput label="Processing Type" />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
          >
            {names.map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={personName.includes(name)} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField id="rawqty" label="Raw Material Quantity" type="text" autoComplete="current-text" />
        <TextField id="rawunit" label="Unit" type="text" autoComplete="current-text" />
        <TextField id="finishedqty" label="Finished Goods Quantity" type="text" autoComplete="current-text" />
        <TextField id="finishedunit" label="Unit" type="text" autoComplete="current-text" />
        <TextField id="date" label="Date" type="date" autoComplete="current-text" />
        <TextField id="others" label="Others" multiline rows={4} />
        <div style={{ marginTop: 2, textAlign: 'center', width: '100%' }}>
          {loading ? (
            <Button variant="outlined" startIcon={<Progress />} disabled>
              Loading...
            </Button>
          ) : (
            <Button variant="outlined" size="large" onClick={addProcess}>
              Submit Processing
            </Button>
          )}
        </div>
      </Box>
    );
  };

  const dispatchGoods = () => {
    const addProcess = async () => {
      setLoading(true);
      try {
        const res = await axios.post('https://server.agrotraciserp.com/api/purchase/editpurchase/', {
          id: props.chosen.id,
          haullier: center,
          status: 'Despatched',
          processingtype: personName,
          dispatchqty: document.getElementById('supplyqty').value,
          dispatchunit: document.getElementById('supplyunit').value,
          dispatchdate: document.getElementById('date').value,
          others: document.getElementById('others').value,
        });

        if (res.status === 200) {
          setLoading(false);
          dispatch(getpurchase({ data: res.data }));
          setSnackbarMessage('Dispatch submitted successfully!');
          setSnackbarOpen(true);
          clearDispatchForm();
          setTimeout(() => handleClose(), 1500); // Close dialog after 1.5s
        } else {
          setLoading(false);
          setSnackbarMessage('Failed to submit dispatch.');
          setSnackbarOpen(true);
        }
      } catch (err) {
        setLoading(false);
        setSnackbarMessage('Error submitting dispatch.');
        setSnackbarOpen(true);
      }
    };

    return (
      <Box
        component="form"
        sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
        noValidate
        autoComplete="off"
      >
        <TextField
          id="outlined-select-currency-native"
          select
          label="Haullier"
          value={center}
          onChange={(e) => setCenter(e.target.value)}
          SelectProps={{ native: true }}
        >
          <option value="none">Choose Haullier</option>
          {agent.map((list) => (
            <option key={list.haullier} value={list.haullier}>
              {list.haullier}
            </option>
          ))}
        </TextField>
        <FormControl sx={{ m: 1, width: 225 }}>
          <InputLabel id="demo-multiple-checkbox-label">Processing Type</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={personName}
            onChange={handleChange}
            input={<OutlinedInput label="Processing Type" />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
          >
            {names.map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={personName.includes(name)} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField id="supplyqty" label="Goods Quantity" type="text" autoComplete="current-text" />
        <TextField id="supplyunit" label="Unit" type="text" autoComplete="current-text" />
        <TextField id="date" label="Date" type="date" autoComplete="current-text" />
        <TextField id="others" label="Others" multiline rows={4} />
        <div style={{ marginTop: 2, textAlign: 'center', width: '100%' }}>
          {loading ? (
            <Button variant="outlined" startIcon={<Progress />} disabled>
              Loading...
            </Button>
          ) : (
            <Button variant="outlined" size="large" onClick={addProcess}>
              Submit Dispatch
            </Button>
          )}
        </div>
      </Box>
    );
  };

  return (
    <div>
      <Dialog fullWidth minWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          {props.name === 'Process Goods' && 'Process Raw Material'}
          {props.name === 'Dispatch Goods' && 'Dispatch Goods'}
          <IconButton onClick={handleClose} style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <p>
            <b>Batch Number: {props.chosen.batch}</b>
          </p>
          {props.name === 'Process Goods' && processGoods()}
          {props.name === 'Dispatch Goods' && dispatchGoods()}
        </DialogContent>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarMessage.includes('success') ? 'success' : 'error'}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}